import { ArticlesModuleLayout } from "@features/creation/components/ArticlesModuleLayout";
import { createFileRoute } from "@tanstack/react-router";

/**
 * Creation Module Route
 *
 * Layout wrapper for the Creation feature.
 * Permission checks are defined per-feature in child routes.
 */
export const Route = createFileRoute("/_app/creation")({
  staticData: {
    title: "Creation",
    permission: "creation.articles.view",
    module: "creation",
    section: "Creation",
    order: 20,
    showInNav: false,
  },
  component: ArticlesModuleLayout,
});
